import {ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import React from "react";
import {MoreHoriz} from "@mui/icons-material";
import {ToolbarButton} from "@mui/x-data-grid";
import {devopsClearCategorizationTableColumnSettings} from "../settings/CategorizationColumnSettings.ts";
import {devopsClearCategorizationTableSettings} from "../settings/CategorizationTableSettings.ts";

export const ToolbarMoreMenu: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <>
        <Tooltip title="More options">
            <ToolbarButton
                id="more-menu-button"
                onClick={handleOpen}>
                <MoreHoriz fontSize="small"/>
            </ToolbarButton>
        </Tooltip>
        <Menu
            id="more-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
        >
            <MenuItem onClick={() => {
                devopsClearCategorizationTableColumnSettings();
                devopsClearCategorizationTableSettings();
                window.location.reload();
            }}>
                <ListItemText>Reset table settings</ListItemText>
            </MenuItem>
        </Menu>
    </>
}
